import { render, staticRenderFns } from "./course-student.vue?vue&type=template&id=1a844466&scoped=true"
import script from "./course-student.vue?vue&type=script&lang=js"
export * from "./course-student.vue?vue&type=script&lang=js"
import style0 from "./course-student.vue?vue&type=style&index=0&id=1a844466&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a844466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a844466')) {
      api.createRecord('1a844466', component.options)
    } else {
      api.reload('1a844466', component.options)
    }
    module.hot.accept("./course-student.vue?vue&type=template&id=1a844466&scoped=true", function () {
      api.rerender('1a844466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/course-student.vue"
export default component.exports